/* hs-eslint ignored failing-rules */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { parse as parseQuery } from 'hub-http/helpers/params';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'hub-... Remove this comment to see the full error message
import HubPicker from 'hub-pickers-lib/components/HubPicker';
import { getRedirectQuery, getNextRedirectUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
class HomeContainer extends Component {
  render() {
    const {
      filter
    } = this.props;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'search' does not exist on type '{ search... Remove this comment to see the full error message
    const {
      search
    } = this.props.location;
    const query = parseQuery(search.substr(1));
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "INDEX_LOAD",
      children: /*#__PURE__*/_jsx(HubPicker, {
        redirectTo: getNextRedirectUrl(query),
        filter: filter,
        shouldWarnAboutObscured: true,
        query: getRedirectQuery(query)
      })
    });
  }
}
HomeContainer.propTypes = {
  filter: PropTypes.string,
  userId: PropTypes.number,
  filterAccounts: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string
  })
};
const mapStateToProps = state => ({
  filter: state.accounts.get('filter'),
  userId: state.auth.user.user_id
});
export default connect(mapStateToProps, {})(HomeContainer);